import { render, staticRenderFns } from "./Upsell.vue?vue&type=template&id=67496fa0&"
import script from "./Upsell.vue?vue&type=script&lang=js&"
export * from "./Upsell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports